/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Status of the loan disbursement
 */
export type DisbursementStatus = typeof DisbursementStatus[keyof typeof DisbursementStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DisbursementStatus = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;
